<template>
  <div class="orderGoods">
    <div class="total">共{{ cartNum }}件商品</div>
    <div class="goodWrapper">
      <div v-for="(item, index) in cartInfo" :key="index" class="store">
        <div class="one">
          <div>
            <div class="iconfont icon-xinpin title"><span>{{item.mer_name}}</span></div>
          </div>
          <div class="list">
            <div class="item acea-row row-between-wrapper" v-for="(sub_item, sub_index) in item.product_list"
              :key="sub_index">
              <div class="picTxt acea-row row-between-wrapper">
                <div class="pictrue">
                  <img :src="sub_item.productInfo.image" class="image" />
                </div>
                <div class="text">
                  <div class="acea-row row-between-wrapper">
                    <div class="name line1">{{ sub_item.productInfo.store_name }}</div>
                    <div class="num">x {{ sub_item.cart_num }}</div>
                  </div>
                  <div class="attr line1" v-if="sub_item.productInfo.attrInfo">
                    {{ sub_item.productInfo.attrInfo.suk }}
                  </div>
                  <div class="money font-color-red" v-if="activity == 4">{{ sub_item.truePrice }}积分</div>
                  <div class="money font-color-red" v-else>￥{{ sub_item.truePrice }}</div>
                  
                  <div class="evaluate" v-if="evaluate === 3"
                    @click="$router.push({ path: '/goods_evaluate/' + sub_item.unique })">
                    评价
                  </div>
                </div>
              </div>

            </div>

          </div>
          <div class="remark">
              <div>备注信息</div>
              <textarea placeholder="请添加备注（150字以内）" v-model="item.mark"></textarea>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "OrderGoods",
    props: {
      evaluate: Number,
      cartNum: Number,
      activity: {
        type: Number,
        default: 0
      },
      cartInfo: {
        type: Array,
        default: () => []
      },
    },
    data: function () {
      return {};
    },
    mounted: {},
    methods: {

    }
  };
</script>

<style scoped>
.orderGoods .remark {
    padding: 0.27rem 0.3rem;
    font-size: 0.3rem;
    color: #282828;
    border-bottom: 1px solid #f0f0f0;
}

.orderGoods .remark textarea {
    background-color: #f9f9f9;
    width: 6.9rem;
    height: 1.4rem;
    border-radius: 0.03rem;
    margin-top: 0.3rem;
    padding: 0.25rem 0.28rem;
}

.orderGoods .remark textarea::placeholder {
    color: #ccc;
}













</style>